import React from "react";
// TODO implement this with webpack
import SvgIcon from "@material-ui/core/SvgIcon";
// import Facebook from "images/facebook.svg";
// import Instagram from "images/instagram.svg";
// import LinkedIn from "images/linkedIn.svg";
// import Medium from "images/medium.svg";
// import Telegram from "images/telegram.svg";
// import Twitter from "images/twitter.svg";
// import Bookmarks from "images/bookmarks.svg";
// import BookmarkAdd from "images/bookmark-add.svg";
// import CloudUpload from "images/cloud-upload.svg";
// import PencilCreate from "images/pencil-create.svg";
// import ThumbsUp from "images/thumbs-up.svg";
// import TrashEmpty from "images/trash-empty.svg";
// import Edit from "images/pencil-edit.svg";
// import ArrowRight from "images/arrow-right.svg";
// import User from "images/user.svg";
// import FileDraft from "images/file-draft.svg";
// import LogoutCircle from "images/logout-circle.svg";

interface Props {
  type:
    | "facebook"
    | "instagram"
    | "linkedIn"
    | "medium"
    | "telegram"
    | "twitter"
    | "bookmarks"
    | "bookmarks-add"
    | "cloud-upload"
    | "pencil-create"
    | "thumbs-up"
    | "trash-empty"
    | "edit"
    | "arrow-right"
    | "arrow-left"
    | "user"
    | "file-draft"
    | "check-mark"
    | "logout-circle"
    | "youTube"
    | "website";
  color: string;
  size?: number;
}

const CustomIcon: React.FunctionComponent<Props> = ({
  type,
  color,
  size = 24,
}) => {
  return (
    <SvgIcon style={{ fontSize: size }}>
      {type === "facebook" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / logos / facebook</title>
          <g
            id="24-/-logos-/-facebook"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M15,7 L15,9 L14,9 C13.4477153,9 13,9.44771525 13,10 L13,11.0043945 L15,11 L15,13 L13,13.0043945 L13,18 L11,18 L11,13.0043945 L9,13 L9,11 L11,11.0043945 L11,10 C11,8.34314575 12.3431458,7 14,7 L15,7 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "instagram" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / logos / instagram</title>
          <g
            id="24-/-logos-/-instagram"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M16,2 C19.3137085,2 22,4.6862915 22,8 L22,16 C22,19.3137085 19.3137085,22 16,22 L8,22 C4.6862915,22 2,19.3137085 2,16 L2,8 C2,4.6862915 4.6862915,2 8,2 L16,2 Z M16,4 L8,4 C5.790861,4 4,5.790861 4,8 L4,16 C4,18.209139 5.790861,20 8,20 L16,20 C18.209139,20 20,18.209139 20,16 L20,8 C20,5.790861 18.209139,4 16,4 Z M12,7 C14.7614237,7 17,9.23857625 17,12 C17,14.7614237 14.7614237,17 12,17 C9.23857625,17 7,14.7614237 7,12 C7,9.23857625 9.23857625,7 12,7 Z M12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 Z M17,6 C17.5522847,6 18,6.44771525 18,7 C18,7.55228475 17.5522847,8 17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "linkedIn" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / logos / linkedin</title>
          <g
            id="24-/-logos-/-linkedin"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M20,2 C21.1045695,2 22,2.8954305 22,4 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,4 C2,2.8954305 2.8954305,2 4,2 L20,2 Z M20,4 L4,4 L4,20 L20,20 L20,4 Z M12,9 L12.0001827,9.25395911 C12.4629788,9.08564839 12.9747185,9 13.5,9 C15.3708601,9 16.8918072,10.2483726 16.9944756,11.8293757 L17,12 L17,17 L15,17 L15,12 C15,11.5180085 14.3956568,11 13.5,11 C12.6866203,11 12.0799682,11.3473849 12.0073139,11.8891093 L12,12 L12,17 L10,17 L10,9 L12,9 Z M9,9 L9,17 L7,17 L7,9 L9,9 Z M8,6 C8.55228475,6 9,6.44771525 9,7 C9,7.55228475 8.55228475,8 8,8 C7.44771525,8 7,7.55228475 7,7 C7,6.44771525 7.44771525,6 8,6 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "medium" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / logos / medium</title>
          <g
            id="24-/-logos-/-medium"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M8.29460825,3 L12.89232,11.0459956 L16.0644701,3.64431215 L16.2792408,3 L22.618034,3 L21,6.23606798 L21,16.763932 L22.618034,20 L13.381966,20 L15,16.763932 L15,11.2052577 L11.1280881,20.2397187 L6,11.2655644 L6,16.9347524 L8.61803399,20 L1.38196601,20 L4,16.9347524 L4,7.76556444 L1.27682032,3 L8.29460825,3 Z M19.381966,5 L17.7207592,5 L17,7.16227766 L17,17.236068 L16.618034,18 L19.381966,18 L19,17.236068 L19,5.76393202 L19.381966,5 Z M7.13396318,5 L4.72317968,5 L10.8719119,15.7602813 L11.9051048,13.3494978 L7.13396318,5 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "telegram" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / logos / telegram</title>
          <g
            id="24-/-logos-/-telegram"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M21.9053935,4.81895394 C21.968363,5.01835728 21.9731908,5.2315783 21.919311,5.43362736 L18.0057064,20.1096448 C17.8491729,20.6966453 17.2464195,21.0456078 16.659419,20.8890743 C16.512169,20.8498076 16.3746845,20.7803724 16.2556834,20.6851716 L12.074216,17.3399976 L9.83923089,19.5749827 C9.40965417,20.0045594 8.71317269,20.0045594 8.28359597,19.5749827 C8.13003537,19.4214221 8.02536474,19.2258432 7.98277469,19.012893 L7.11533655,14.6757023 L1.77366185,12.0048649 C1.2302855,11.7331767 1.01003872,11.0724364 1.28172689,10.52906 C1.41490389,10.262706 1.65038222,10.0617288 1.9343523,9.97205407 L20.5252081,4.10125751 C21.1045222,3.91831622 21.7224522,4.23963986 21.9053935,4.81895394 Z M19.5645258,6.50198441 L4.65596804,11.20995 L8.04535584,12.9039036 L15.6180078,9.87576391 L12.2533558,14.9219036 L16.4284794,18.2621587 L19.5645258,6.50198441 Z M10.3819922,14.1242361 L9.14335584,14.6189036 L9.40835584,15.9459036 L10.1055728,14.5527864 L10.1679497,14.4452998 L10.3819922,14.1242361 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "twitter" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / logos / twitter</title>
          <g
            id="24-/-logos-/-twitter"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M4.75654233,3.34149261 L4.02287753,2.50302481 L3.26826752,3.32269306 C2.87219895,3.75290844 2.57791125,4.22243401 2.37431597,4.72961755 C2.08311318,5.45504333 2.00647116,6.03651741 2.00072724,7.02223245 L2.00158979,7.50454712 L2.00595441,7.78428679 C2.07287699,9.90417429 2.90935438,11.4542545 4.51286378,12.4489602 L4.599,12.5 L4.55444592,12.5091905 C4.38881074,12.5369135 4.20547244,12.5519104 4.00396807,12.5519104 L3.00396807,12.5519104 L3.00396807,13.5519104 L3.00831141,13.7401396 C3.08928916,15.4691569 4.29984597,16.422514 6.40985028,16.8045429 L6.6,16.836 L6.44125539,16.8968193 C5.62446777,17.1887493 4.58940749,17.4067172 3.40695739,17.5154633 L2.0125787,17.6436997 L2.58634135,18.9210145 C3.14364186,20.1616811 4.36151784,20.8715659 5.99801451,21.2286792 C6.99243514,21.4456798 7.86087855,21.5004578 9.00390874,21.5004578 L9.27442869,21.4974336 C14.7791567,21.3745903 20.5048796,17.5179549 20.5048796,11.5045471 L20.504,9.117 L20.5868879,8.9849687 C20.5932814,8.97538058 20.7300073,8.77567776 20.7700265,8.71289733 L20.8435409,8.59326379 C20.8877355,8.51750542 20.9223934,8.44822677 20.9480727,8.37633834 L20.963,8.324 L22.5346443,5.17651853 L21.1199059,5.01129757 L20.6539916,4.9512288 C20.3486254,4.90802762 20.0537484,4.85852309 19.7693784,4.80275913 L19.63,4.773 L19.5245644,4.67306827 C18.6904906,3.92016192 17.6484645,3.50454712 16.5047032,3.50454712 L16.2860334,3.50926742 C13.8985509,3.61277529 12.1122085,5.40739842 12.0091949,7.7866699 L12.004,7.983 L11.9644458,7.98028091 C9.53813403,7.76258091 7.16106423,6.08949711 4.75654233,3.34149261 Z M16.5047032,5.50454712 C17.2363038,5.50454712 17.8788278,5.80157255 18.3907321,6.36330003 L18.6024489,6.59562315 L18.9090094,6.6650405 L19.3808817,6.76466692 L19.496,6.785 L19.0252478,7.72464385 L18.9229008,7.87539812 L18.7890162,8.08786923 C18.7690145,8.12204392 18.7499548,8.15606237 18.7315161,8.19061812 C18.5900383,8.4557586 18.5048796,8.71076453 18.5048796,9.00454712 L18.5048796,11.5045471 C18.5048796,16.2918338 13.61833,19.5004578 9.00390874,19.5004578 L8.72325501,19.4985821 C7.73571722,19.4851904 6.86028115,19.3995168 6.15408275,19.2232217 L5.872,19.144 L6.09487416,19.0901522 C8.45625642,18.4908005 10.0042621,17.3938657 10.0042621,16.0045471 L10.0042621,15.0045471 L9.00426213,15.0045471 L8.71964014,15.0026871 C7.04623189,14.9803959 5.98879018,14.7582507 5.4469196,14.3638922 L5.423,14.345 L5.55067888,14.3052204 C6.71037057,13.9136696 7.49292241,13.1061774 7.49292241,12.2502289 L7.49292241,11.5187753 L6.79583337,11.29721 C4.90406278,10.6959228 4.06460666,9.63485586 4.00501975,7.72830754 L4.0007792,7.29029388 L4.0005557,7.07198965 C4.00322546,6.44569183 4.03754356,6.06846664 4.14633028,5.7118632 L4.165,5.655 L4.35261261,5.84914472 C6.93057949,8.47395127 9.5777563,10.0045471 12.504468,10.0045471 C13.4099335,10.0045471 13.8502504,9.37418809 13.968662,8.589173 C13.9983366,8.39244357 14.0044974,8.24276105 14.0044974,8.00454712 C14.0044974,6.54693202 15.0417313,5.50454712 16.5047032,5.50454712 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "bookmarks" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="24-/-basic-/-bookmarks"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M15,5 C16.1045695,5 17,5.8954305 17,7 L17,22.618034 L10,19.118034 L3,22.618034 L3,7 C3,5.8954305 3.8954305,5 5,5 L15,5 Z M15,7 L5,7 L5,19.381966 L10,16.881966 L15,19.381966 L15,7 Z M19,1 C20.1045695,1 21,1.91055224 21,3.03377535 L21,18.9324493 L19,17.9155616 L19,3 L8.00027023,3 C8.01800608,1.89235536 8.9065233,1 10,1 L19,1 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "bookmarks-add" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="24-/-basic-/-bookmark-add"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M17,2 C18.1045695,2 19,2.8954305 19,4 L19,5 L17,5 L17,4 L7,4 L7,19.381966 L12,16.881966 L17,19.381966 L17,17 L19,17 L19,22.618034 L12,19.118034 L5,22.618034 L5,4 C5,2.8954305 5.8954305,2 7,2 L17,2 Z M20,8 L20,10 L22,10 L22,12 L20,12 L20,14 L18,14 L18,12 L16,12 L16,10 L18,10 L18,8 L20,8 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "cloud-upload" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / software / cloud-upload</title>
          <g
            id="24-/-software-/-cloud-upload"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M12,10.5857864 L16.7071068,15.2928932 L15.2928932,16.7071068 L13,14.4142136 L13,21 L11,21 L11,14.4142136 L8.70710678,16.7071068 L7.29289322,15.2928932 L12,10.5857864 Z M12,4 C15.1586186,4 17.8750012,6.1056212 18.7254431,9.0522437 C21.1430685,9.40362782 23,11.4849591 23,14 C23,16.7614237 20.7614237,19 18,19 L17,19 L17,17 L18,17 C19.6568542,17 21,15.6568542 21,14 C21,12.3431458 19.6568542,11 18,11 L17.9374883,11.0006341 L17.9374883,11.0006341 L17.0737589,11.0181765 L16.9309417,10.1661557 C16.5303438,7.77626335 14.4511274,6 12,6 C10.1923998,6 8.55429829,6.96642863 7.6664163,8.50398349 L7.39066076,8.98151234 L6.83965518,9.0031404 C4.69934052,9.08715198 3,10.8504451 3,13 C3,15.209139 4.790861,17 7,17 L7,19 C3.6862915,19 1,16.3137085 1,13 C1,9.95876977 3.26703071,7.43346119 6.21989093,7.05027488 C7.50901474,5.16507238 9.65343535,4 12,4 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "pencil-create" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / editing / pencil-create</title>
          <g
            id="24-/-editing-/-pencil-create"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M16.43735,2 C17.0920882,2 17.7197259,2.26141978 18.1781068,2.7234227 L21.2790059,5.82432181 C21.7406843,6.28599904 22.0000526,6.91216845 22.0000526,7.56507948 C22.0000526,8.21799052 21.7406843,8.84415992 21.2790068,9.30583626 L9.95750718,20.6237545 C9.25902448,21.4294925 8.26890003,21.9245308 7.1346,22.0023295 L2,22.0023295 L2,21.0023295 L2.00324765,16.7873015 C2.08843822,15.7328366 2.57866679,14.7523321 3.32649633,14.0934196 L14.6953877,2.72462818 C15.1563921,2.2608295 15.7833514,2 16.43735,2 Z M12.302,7.945 L4.69610276,15.549589 C4.29095108,15.9079238 4.04030835,16.4092335 4,16.8678295 L4,20.0029438 L7.06398288,20.004826 C7.5982069,19.9670062 8.09548693,19.7183782 8.49479322,19.2616227 L16.056,11.699 L12.302,7.945 Z M16.43735,4 C16.3157645,4 16.1992116,4.04854589 16.1135757,4.13485646 L13.716,6.531 L17.47,10.285 L19.8647941,7.89162181 C19.9513987,7.80501747 20.0000526,7.68755666 20.0000526,7.56507948 C20.0000526,7.4426023 19.9513987,7.32514149 19.8647932,7.23853626 L16.7611243,4.13485646 C16.6754884,4.04854589 16.5589355,4 16.43735,4 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "thumbs-up" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / basic / thumbs-up</title>
          <g
            id="24-/-basic-/-thumbs-up"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M13,1.99910445 C13.6147967,1.99910445 14.1422801,2.04513312 14.748281,2.22159137 C16.091867,2.61282321 17,3.52709845 17,4.99910445 C17,5.51921677 16.9079007,6.07373891 16.7382242,6.68923415 C16.6259612,7.09646424 16.4872151,7.50766133 16.2970775,8.01801005 C16.2391583,8.17347129 16.007193,8.78168345 15.9547911,8.92337824 L15.9269768,8.99910445 L15.9269768,8.99910445 L19,8.99910445 C20.8695981,8.99910445 22,10.316625 22,11.9991044 C22,17.9426745 20.7551411,21.9991044 18,21.9991044 L11.0344006,21.9985135 C10.3408482,22.0111947 9.50544052,21.9186578 8.66312366,21.6172857 C8.29462039,21.4854391 7.95563707,21.3213574 7.65188662,21.1247204 C7.29343384,21.6534226 6.68719067,22 6,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,11 C2,9.8954305 2.8954305,9 4,9 L6,9 C6.19830237,9 6.38986405,9.02886035 6.57071391,9.08260993 C7.64176978,7.5210365 11.2551125,3.57494327 12.2202699,2.37298955 L12.5204954,1.99910445 L13,1.99910445 Z M13.4599624,4.01423587 C11.914268,5.86195611 8.40663864,9.70054105 8.14171093,10.3190878 C8.04595153,10.5426645 8.00140139,10.7522598 8,10.9878662 L8,18.0241052 L8.00602058,18.1744601 C8.0621864,18.9692804 8.51096058,19.4386839 9.33687634,19.7341879 C9.91062406,19.9394688 10.5253746,20.0075638 10.963066,19.9997143 L18,19.9991054 C19.015127,19.9991054 20,16.7898506 20,11.9991054 C20,11.3589955 19.6912225,10.9991054 19,10.9991054 L15,10.9991054 C13.8054549,10.9991054 13.5555377,10.0754586 13.8046536,9.07541689 C13.8632547,8.84017106 13.9489218,8.5812741 14.0789589,8.22965366 C14.1358033,8.07594642 14.3689242,7.46470447 14.4229225,7.31976744 C14.5944107,6.85947528 14.7161494,6.4986824 14.8101464,6.1577119 C14.9359344,5.70142019 15,5.31568707 15,4.99910538 C15,4.54813166 14.7621788,4.30870189 14.1891338,4.1418399 C13.9483736,4.07173418 13.7113931,4.0330943 13.4599624,4.01423587 Z M6,11 L4,11 L4,20 L6,20 L6,11 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "trash-empty" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / basic / trash-empty</title>
          <g
            id="24-/-basic-/-trash-empty"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M15,1 C16.1045695,1 17,1.8954305 17,3 L17,4 L20,4 C21.1045695,4 22,4.8954305 22,6 L22,8 C22,9.1045695 21.1045695,10 20,10 L19.919,10 L19,21 C19,22.1045695 18.1045695,23 17,23 L7,23 C5.8954305,23 5,22.1045695 5.00345424,21.0830455 L4.08,10 L4,10 C2.8954305,10 2,9.1045695 2,8 L2,6 C2,4.8954305 2.8954305,4 4,4 L7,4 L7,3 C7,1.8954305 7.8954305,1 9,1 L15,1 Z M17.913,10 L6.086,10 L7,21 L17,21 L17.0034542,20.9169545 L17.913,10 Z M14.2928932,11.2928932 L15.7071068,12.7071068 L13.415,15 L15.7071068,17.2928932 L14.2928932,18.7071068 L12,16.415 L9.70710678,18.7071068 L8.29289322,17.2928932 L10.585,15 L8.29289322,12.7071068 L9.70710678,11.2928932 L12,13.585 L14.2928932,11.2928932 Z M20,6 L4,6 L4,8 L20,8 L20,6 Z M15,3 L9,3 L9,4 L15,4 L15,3 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "edit" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / editing / pencil-edit</title>
          <g
            id="24-/-editing-/-pencil-edit"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M11,2 L11,4 L4,4 L4,20 L20,20 L20,13 L22,13 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,4 C2,2.8954305 2.8954305,2 4,2 L11,2 Z M17.43735,2 C18.0920882,2 18.7197259,2.26141978 19.1781068,2.7234227 L21.2790059,4.82432181 C21.7406843,5.28599904 22.0000526,5.91216845 22.0000526,6.56507948 C22.0000526,7.21799052 21.7406843,7.84415992 21.2790068,8.30583626 L12.9575072,16.6237545 C12.2590245,17.4294925 11.2689,17.9245308 10.1346,18.0023295 L6,18.0023295 L6,17.0023295 L6.00324765,13.7873015 C6.08843822,12.7328366 6.57866679,11.7523321 7.32649633,11.0934196 L15.6953877,2.72462818 C16.1563921,2.2608295 16.7833514,2 17.43735,2 Z M14.802,6.445 L8.69610276,12.549589 C8.29095108,12.9079238 8.04030835,13.4092335 8,13.8678295 L8,16.0029438 L10.0639829,16.004826 C10.5982069,15.9670062 11.0954869,15.7183782 11.4947932,15.2616227 L17.556,9.199 L14.802,6.445 Z M17.43735,4 C17.3157645,4 17.1992116,4.04854589 17.1135757,4.13485646 L16.216,5.031 L18.97,7.785 L19.8647941,6.89162181 C19.9513987,6.80501747 20.0000526,6.68755666 20.0000526,6.56507948 C20.0000526,6.4426023 19.9513987,6.32514149 19.8647932,6.23853626 L17.7611243,4.13485646 C17.6754884,4.04854589 17.5589355,4 17.43735,4 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "arrow-right" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="24-/-arrows-/-arrow-right"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <polygon
              id="icon"
              fill={color}
              points="17.5857864 13 3 13 3 11 17.5857864 11 11.2928932 4.70710678 12.7071068 3.29289322 21.4142136 12 12.7071068 20.7071068 11.2928932 19.2928932"
            ></polygon>
          </g>
        </svg>
      ) : type === "user" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / editing / user</title>
          <g
            id="24-/-editing-/-user"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,17 C8.43085179,17 6.3282764,17.6872588 6.03537538,18.739557 C7.6239243,20.1464312 9.71228132,21 12,21 C14.2877187,21 16.3760757,20.1464312 17.96397,18.7403948 C17.6717236,17.6872588 15.5691482,17 12,17 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,13.9044252 3.59150865,15.6706961 4.60082741,17.1251142 C5.72654778,15.6379201 8.37101117,15 12,15 C15.6289888,15 18.2734522,15.6379201 19.3991156,17.1241447 C20.4084913,15.6706961 21,13.9044252 21,12 C21,7.02943725 16.9705627,3 12,3 Z M12,6 C14.4141948,6 16,7.92157821 16,10.2 C16,13.479614 14.2180861,15 12,15 C9.76086382,15 8,13.4273743 8,10 C8,7.75575936 9.57909957,6 12,6 Z M12,8 C10.7337387,8 10,8.81582479 10,10 C10,12.2692568 10.8182108,13 12,13 C13.1777063,13 14,12.2983927 14,10.2 C14,8.95041736 13.2156568,8 12,8 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "file-draft" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / file / file-draft</title>
          <g
            id="24-/-file-/-file-draft"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M17,21 L17,23 L15,23 L15,21 L17,21 Z M21,21 C21,22.1045695 20.1045695,23 19,23 L19,21 L21,21 Z M13,21 L13,23 L11,23 L11,21 L13,21 Z M9,21 L9,23 L7,23 L7,21 L9,21 Z M5,21 L5,23 C3.8954305,23 3,22.1045695 3,21 L5,21 Z M21,17 L21,19 L19,19 L19,17 L21,17 Z M5,17 L5,19 L3,19 L3,17 L5,17 Z M21,13 L21,15 L19,15 L19,13 L21,13 Z M5,13 L5,15 L3,15 L3,13 L5,13 Z M15.4142136,1 L21,6.58578644 L21,11 L19,11 L19,9 L15,9 C13.8954305,9 13,8.1045695 13,7 L13,3 L5,3 L5,11 L3,11 L3,3 C3,1.8954305 3.8954305,1 5,1 L15.4142136,1 Z M15,3.41421356 L15,7 L18.5857864,7 L15,3.41421356 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "logout-circle" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / basic / logout-circle</title>
          <g
            id="24-/-basic-/-logout-circle"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M12,2 C13.5802619,2 15.1100398,2.36760414 16.4920841,3.06354295 L15.5925767,4.84984818 C14.488,4.29363027 13.266063,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C13.2669938,20 14.4897931,19.705937 15.5949937,19.1489342 L16.4951079,20.9349337 C15.1122849,21.6318536 13.5814255,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M18.7071068,7.29289322 L23.4142136,12 L18.7071068,16.7071068 L17.2928932,15.2928932 L19.5857864,13 L10,13 L10,11 L19.5857864,11 L17.2928932,8.70710678 L18.7071068,7.29289322 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "arrow-left" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / arrows / arrow-left</title>
          <g
            id="24-/-arrows-/-arrow-left"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <polygon
              id="icon"
              fill={color}
              points="6.41421356 13 12.7071068 19.2928932 11.2928932 20.7071068 2.58578644 12 11.2928932 3.29289322 12.7071068 4.70710678 6.41421356 11 21 11 21 13"
            ></polygon>
          </g>
        </svg>
      ) : type === "website" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="24-/-basic-/-globe"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M14.8253323,14.8437192 L14.6575229,14.862182 C13.7963901,14.9518692 12.9044542,15 12,15 C11.020936,15 10.076116,14.9581553 9.17906161,14.8773472 C9.63333311,18.4571632 10.8764098,21 12,21 C13.1270429,21 14.3743077,18.4415113 14.8253323,14.8437192 Z M20.9211343,13.1967169 L20.8864583,13.214391 C19.830601,13.7578852 18.4474234,14.2124349 16.8791649,14.5268975 C16.6537922,16.8293177 16.1206083,18.8615687 15.3451452,20.3582823 C18.3042661,19.1724864 20.4874498,16.4609091 20.9211343,13.1967169 Z M3.1042953,13.366479 L3.11846441,13.463946 C3.63285472,16.608449 5.77688763,19.2049454 8.65500314,20.3578752 C7.88883536,18.8796087 7.35918551,16.8784973 7.12912742,14.610703 C5.52351084,14.3316775 4.14742122,13.9095343 3.1042953,13.366479 Z M12,3 C10.5936028,3 9,6.98399319 9,12 C9,12.2870966 9.00522059,12.5708123 9.01532787,12.8505937 C9.95398206,12.9483204 10.9560716,13 12,13 C13.0277519,13 14.0361571,12.9275354 14.9854688,12.8046169 C14.9953342,12.5398024 15,12.271412 15,12 C15,6.98399319 13.4063972,3 12,3 Z M8.65485476,3.64171772 L8.49679384,3.70726461 C5.58716848,4.93793236 3.45941801,7.65519968 3.06571056,10.9068984 C3.35642065,11.2800883 4.16722841,11.7577914 5.40825505,12.1475117 C5.89644496,12.3008182 6.43109017,12.4355937 7.00473661,12.5500583 C7.00185877,12.3677331 7,12.1843616 7,12 C7,8.6720362 7.60567909,5.66672131 8.65485476,3.64171772 Z M15.3449969,3.64212484 L15.3819541,3.71352262 C16.4084744,5.73740893 17,8.71114983 17,12 C17,12.1519464 16.9987374,12.3032202 16.9962276,12.4537588 C18.9742873,12.0154885 20.4580697,11.3882118 20.9285122,10.8601264 C20.5128083,7.5706772 18.3214555,4.83444936 15.3449969,3.64212484 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "youTube" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="24-/-logos-/-youtube"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <path
              d="M18.8782989,4.11790083 C20.5073007,4.21303163 21.3281267,4.60936303 22.020213,5.8580297 C22.7108012,7.06048454 23,8.93778123 23,11.9972 C23,15.0688707 22.7080514,16.9571365 22.0247481,18.1281724 C21.3347709,19.3777602 20.5269977,19.7708297 18.8782989,19.8862992 C17.7148693,19.9542414 14.794638,20 12.0026667,20 C9.2044172,20 6.28275714,19.9542562 5.10860514,19.8855427 C3.47493151,19.7708031 2.66701263,19.37838 1.97791182,18.142374 C1.29279472,16.9480084 1,15.052042 1,12.0084 C1,8.94737365 1.29138368,7.06090428 1.97193166,5.86259947 C2.67010997,4.61046509 3.49111627,4.21325835 5.11100471,4.1184917 C6.14180983,4.0485852 8.56470861,4.00701529 11.2865567,4.0008115 L12.7173202,4.00081148 C15.4339223,4.00701384 17.8551753,4.04855252 18.8782989,4.11790083 Z M12.7063017,6.00080236 L11.2975982,6.00080239 C8.61667236,6.00693086 6.21963891,6.04789753 5.2370951,6.1144916 C4.22844212,6.17352647 4.03674592,6.26627 3.71489655,6.84342165 C3.2475376,7.66638709 3,9.26898917 3,11.9972 C3,14.7270394 3.24886149,16.33852 3.71873501,17.1577995 C4.03565111,17.7261665 4.22600958,17.8186276 5.23703026,17.8897046 C6.34874254,17.9546989 9.24212825,18 12.0026667,18 C14.7569983,18 17.6489264,17.9546849 18.7500936,17.8904464 C19.7737637,17.8187098 19.961409,17.7274 20.2855157,17.1409953 C20.752236,16.3407623 21,14.7382734 21,12.0084 C21,9.25771396 20.7535449,7.66399511 20.283329,6.84963647 C19.9603324,6.26505017 19.7713697,6.17346202 18.752413,6.11391338 C17.7774091,6.04786473 15.3820594,6.00692931 12.7063017,6.00080236 Z M10,9 L15,12 L10,15 L10,9 Z"
              id="icon"
              fill={color}
            ></path>
          </g>
        </svg>
      ) : type === "check-mark" ? (
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>24 / basic / check-mark</title>
          <g
            id="24-/-basic-/-check-mark"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <rect id="evericons.com" x="0" y="0" width="24" height="24"></rect>
            <polygon
              id="icon"
              fill={color}
              points="9.70710678 14.2928932 19 5 20.4142136 6.41421356 9.70710678 17.1213203 4 11.4142136 5.41421356 10"
            ></polygon>
          </g>
        </svg>
      ) : null}
    </SvgIcon>
  );
};

export default CustomIcon;
